import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeteringServiceProvider } from "../../../../utils/backend-types";
import { MspImportFrequency } from "../../../../utils/enums";
import { getMspImportFrequencyLabel } from "../../utils/getMspImportFrequencyLabel";
import { METERING_SERVICE_PROVIDER_FIELD_LABELS } from "../MeteringServiceProviderTable";

const importFrequencyChoices = Object.values(MspImportFrequency).map(
  (value) => ({
    label: getMspImportFrequencyLabel(value),
    value: value
  })
);

function getImportFrequencyColumn(): MRT_ColumnDef<MeteringServiceProvider> {
  return {
    accessorKey: "importFrequency",
    header: METERING_SERVICE_PROVIDER_FIELD_LABELS.importFrequency,
    size: 140,
    editVariant: "select",
    mantineEditSelectProps: {
      data: importFrequencyChoices
    },
    Cell: ({ renderedCellValue }) =>
      getMspImportFrequencyLabel(renderedCellValue as MspImportFrequency)
  };
}

export { getImportFrequencyColumn };
